// extracted by mini-css-extract-plugin
export var readonly = "_cy-1";
export var star = "_cy-0";